import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "accordian-component" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  id: "accordian-wrap"
}
const _hoisted_4 = {
  key: 0,
  id: "tools"
}
const _hoisted_5 = {
  key: 1,
  id: "accordian-wrap"
}
const _hoisted_6 = {
  key: 0,
  id: "tools"
}

import { defineAsyncComponent, ref, computed, watch, inject } from "vue";
import { Ref } from "@vue/reactivity";
import { store } from "@/store";
import { AccordianState, ClientDimensions } from "@/types";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// Vue 3.2 script setup api
const Shapes = defineAsyncComponent(() =>
  import("@/components/SideToolBar/Tools/Shapes.vue" /* webpackChunkName: "shapes" */)
);
const UploadArt = defineAsyncComponent(() =>
  import("@/components/SideToolBar/Tools/UploadArt.vue" /* webpackChunkName: "uploadArt" */)
);
const TextTool = defineAsyncComponent(() =>
  import("@/components/SideToolBar/Tools/TextTool.vue" /* webpackChunkName: "textTool" */)
);
const ClipArt = defineAsyncComponent(() =>
  import("@/components/SideToolBar/Tools/ClipArt.vue" /* webpackChunkName: "clipArt" */)
);
const Layout = defineAsyncComponent(() =>
  import("@/components/SideToolBar/Tools/Layout.vue" /* webpackChunkName: "layout" */)
);
const Background = defineAsyncComponent(() =>
  import("@/components/SideToolBar/Tools/Background.vue" /* webpackChunkName: "background" */)
);
const Rotate = defineAsyncComponent(() =>
  import("@/components/SideToolBar/Tools/Rotate.vue" /* webpackChunkName: "rotate" */)
);
const Settings = defineAsyncComponent(() =>
  import("@/components/SideToolBar/Tools/Settings.vue" /* webpackChunkName: "settings" */)
);

const isMobile = computed<boolean>(() => store.getters.isMobile);
const clientDimensions = computed<ClientDimensions>(() => store.getters.clientDimensions);

const active = ref(false);
const showTool = ref(false);
const lockToolBar = inject<Ref<boolean>>("lockToolBar", ref(false));
const accordianState = computed<AccordianState>(() => store.getters.accordianState);

watch(accordianState, (newState) => {
  if (!lockToolBar.value) {
    if (isMobile.value || clientDimensions.value.width < 767) {
      if (newState.isOpen) {
        active.value = true;
        showTool.value = true;
      } else {
        active.value = false;
        showTool.value = false;
      }
    } else {
      if (newState.isOpen) active.value = true;
      else showTool.value = false;
    }
  } else {
    //For is the user locks the tool bar while accordian is open
    //Can really only happen in mobile
    if (!newState.isOpen) {
      active.value = false;
      showTool.value = false;
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isMobile) && _unref(clientDimensions).width > 767)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_Transition, {
            name: "expand-left",
            onAfterEnter: _cache[1] || (_cache[1] = ($event: any) => (showTool.value = true))
          }, {
            default: _withCtx(() => [
              (active.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_Transition, {
                      name: "fade",
                      onAfterLeave: _cache[0] || (_cache[0] = ($event: any) => (active.value = false))
                    }, {
                      default: _withCtx(() => [
                        (showTool.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              (_unref(accordianState).tool === 'Shapes')
                                ? (_openBlock(), _createBlock(_unref(Shapes), { key: 0 }))
                                : (_unref(accordianState).tool === 'Image')
                                  ? (_openBlock(), _createBlock(_unref(UploadArt), { key: 1 }))
                                  : (_unref(accordianState).tool === 'Text')
                                    ? (_openBlock(), _createBlock(_unref(TextTool), { key: 2 }))
                                    : (_unref(accordianState).tool === 'ClipArt')
                                      ? (_openBlock(), _createBlock(_unref(ClipArt), { key: 3 }))
                                      : (_unref(accordianState).tool === 'Layout')
                                        ? (_openBlock(), _createBlock(_unref(Layout), { key: 4 }))
                                        : (_unref(accordianState).tool === 'Background')
                                          ? (_openBlock(), _createBlock(_unref(Background), { key: 5 }))
                                          : (_unref(accordianState).tool === 'Rotate')
                                            ? (_openBlock(), _createBlock(_unref(Rotate), { key: 6 }))
                                            : (_unref(accordianState).tool === 'Settings')
                                              ? (_openBlock(), _createBlock(_unref(Settings), { key: 7 }))
                                              : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : (active.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (showTool.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_unref(accordianState).tool === 'Shapes')
                    ? (_openBlock(), _createBlock(_unref(Shapes), { key: 0 }))
                    : (_unref(accordianState).tool === 'Image')
                      ? (_openBlock(), _createBlock(_unref(UploadArt), { key: 1 }))
                      : (_unref(accordianState).tool === 'Text')
                        ? (_openBlock(), _createBlock(_unref(TextTool), { key: 2 }))
                        : (_unref(accordianState).tool === 'ClipArt')
                          ? (_openBlock(), _createBlock(_unref(ClipArt), { key: 3 }))
                          : (_unref(accordianState).tool === 'Layout')
                            ? (_openBlock(), _createBlock(_unref(Layout), { key: 4 }))
                            : (_unref(accordianState).tool === 'Background')
                              ? (_openBlock(), _createBlock(_unref(Background), { key: 5 }))
                              : (_unref(accordianState).tool === 'Rotate')
                                ? (_openBlock(), _createBlock(_unref(Rotate), { key: 6 }))
                                : (_unref(accordianState).tool === 'Settings')
                                  ? (_openBlock(), _createBlock(_unref(Settings), { key: 7 }))
                                  : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})